<template>
    <div class="modal-content lottery-consents-modal">
        <div class="modal-header border-0 text-center">
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">Loteria Leżajsk w M/platform</h2>
            </div>
        </div>
        <div
            class="modal-body pr-4 pl-4 pb-4 text-primary consents-modal__body"
        >
            <div class="tr-data mb-4 is-column">
                <div class="px-3">
                    <p class="typo typo--name mb-3">
                        Witamy Cię w Panelu Detalisty M/platform, który posłuży
                        Ci do obsługi loterii Leżajsk.
                    </p>
                    <p class="typo mb-2">
                        Aby przystąpić do loterii, zapoznaj się z regulaminem, a
                        następnie aktywuj usługę „Loteria Leżajsk” poprzez
                        naciśnięcie poniższego przycisku „Włącz usługę”.
                    </p>
                    <p class="typo mb-2">
                        Wybierz <b>„Rozliczenia”</b> w menu znajdującym się w
                        górnej części ekranu, aby przejść do sekcji, z której
                        pobierzesz dokumenty rozliczeniowe (noty VAT) za
                        produkty wydane w ramach loterii. Dokumenty są
                        wystawiane raz w tygodniu. Przekazuj je regularnie do
                        swojej księgowości, nie rzadziej niż raz w miesiącu.
                    </p>
                    <p class="typo mb-2">
                        Wybierz <b>„Raporty”</b>, aby przejść do sekcji, w
                        której zapoznasz się z raportem liczby wydanych nagród w
                        ramach loterii.
                    </p>
                    <p class="typo mb-2">
                        Wybierz <b>„Usługi”</b>, aby zapoznać się z ofertą usług
                        dostępnych w ramach M/platform – narzędzia wspierającego
                        sklepy takie jak Twój.
                    </p>
                    <p class="typo mb-2">
                        Panel Detalisty M/platform możesz obsługiwać z poziomu
                        komputera, smartfona lub tabletu. Dostęp do Panelu jest
                        bezpłatny.
                    </p>
                    <p class="typo">
                        Jeśli masz jakieś pytania, skontaktuj się z nami pod
                        numerem 22 123 84 00 lub napisz maila na
                        promoplus@mplatform.com.pl
                    </p>
                </div>
                <div
                    class="
                        custom-control custom-checkbox custom-checkbox-lg
                        mt-5
                        d-flex
                        align-items-center
                        agreement
                    "
                >
                    <ui-checkbox-input name="test" v-model="consentState" />
                    <span>
                        Akceptuję
                        <a
                            href="/regulations/Loteria_Lezajsk_Regulamin_dla sklepow.pdf"
                            class="font-weight-bold agreement__consent-link"
                            target="_blank"
                            >regulamin Producenta</a
                        >
                        na przystąpienie do Loterii<span
                            class="agreement__required-star"
                            >*</span
                        >
                    </span>
                </div>
            </div>

            <div class="text-center mt-4">
                <button
                    :disabled="!consentState"
                    class="btn btn-primary ml-auto"
                    @click.prevent="onLotteryConsentAccept"
                >
                    Włącz usługę
                    <button-spinner
                        v-if="requestPending"
                        status="loading"
                        class="ml-3"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            requestPending: false,
            consentState: false,
            consentName:
                '<a>Akceptuję regulamin Producenta na przystąpienie do Loterii</a>',
            consentContent:
                'Treść akceptuję regulamin Producenta na przystąpienie do Loterii, Treść akceptuję regulamin Producenta na przystąpienie do Loterii ,Treść akceptuję regulamin Producenta na przystąpienie do Loterii Treść akceptuję regulamin Producenta na przystąpienie do Loterii,',
            collapsed: false,
            buttonTooltipMessage:
                'Aby zatwierdzić zaznacz swoją decyzję przy każdej zgodzie.'
        }
    },
    methods: {
        async onLotteryConsentAccept() {
            const service = this.$store.getters.getServices.find(
                service => service.code === 'loterie2_g3'
            )
            if (service) {
                try {
                    this.requestPending = true
                    await this.$store.dispatch('sendServiceActivateRequest', {
                        serviceId: service.id,
                        shopIds: this.$store.getters.getAllServiceShopIds,
                        allShops: true,
                        level: service.level
                    })
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Włączono dostęp do usługi Loterii.'
                    })
                    this.$emit('accept')
                } catch (err) {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                } finally {
                    this.requestPending = false
                }
            }
        }
    }
}
</script>
<style lang="scss">
.lottery-consents-modal {
    .agreement {
        &__consent-link {
            text-decoration: underline;
            color: var(--color-primary);
            &:hover {
                color: var(--color-primary);
            }
        }
        &__required-star {
            color: var(--danger);
        }
    }
}
</style>
